import { MemberProfile } from '../../models';
import axios from 'axios';
import { constants } from '../../constants';

export const getMemberProfile = (memberId: string) => {
  const token = localStorage.getItem('token');
  return axios.get<MemberProfile>(
    `${constants.endpoint}/users/${memberId}/profile`, {
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  ).then(response => response.data);
};
